<h2>الإعدادات الأمنية</h2>

<div class="grid">
  <div class="card">
    <h3>إعدادات الأمان</h3>
    <div class="row">
      <label>أقصى عدد محاولات فاشلة</label>
      <p-inputNumber [(ngModel)]="sec.maxFailedAccessAttempts"></p-inputNumber>
    </div>
    <div class="row">
      <label>مدة القفل (بالدقائق)</label>
      <p-inputNumber [(ngModel)]="sec.lockoutMinutes"></p-inputNumber>
    </div>
    <div class="row">
      <label>أقصى عدد جلسات متزامنة</label>
      <p-inputNumber [(ngModel)]="sec.maxConcurrentSessions"></p-inputNumber>
    </div>
    <div class="row">
      <label>الجلسة المنزلقة (بالدقائق)</label>
      <p-inputNumber [(ngModel)]="sec.slidingSessionMinutes"></p-inputNumber>
    </div>
    <button
      pButton
      icon="pi pi-save"
      label="حفظ"
      (click)="saveSecurity()"
    ></button>
  </div>

  <div class="card">
    <h3>سياسة كلمة المرور</h3>
    <div class="row">
      <label>الطول الأدنى</label>
      <p-inputNumber [(ngModel)]="pwd.minLength"></p-inputNumber>
    </div>
    <div class="row">
      <label>حرف كبير (A-Z) مطلوب</label>
      <p-inputSwitch [(ngModel)]="pwd.requireUpper"></p-inputSwitch>
    </div>
    <div class="row">
      <label>حرف صغير (a-z) مطلوب</label>
      <p-inputSwitch [(ngModel)]="pwd.requireLower"></p-inputSwitch>
    </div>
    <div class="row">
      <label>رقم مطلوب</label>
      <p-inputSwitch [(ngModel)]="pwd.requireDigit"></p-inputSwitch>
    </div>
    <div class="row">
      <label>رمز مطلوب</label>
      <p-inputSwitch [(ngModel)]="pwd.requireSymbol"></p-inputSwitch>
    </div>
    <div class="row">
      <label>تذكّر آخر N كلمات مرور</label>
      <p-inputNumber [(ngModel)]="pwd.rememberLastN"></p-inputNumber>
    </div>
    <div class="row">
      <label>تنتهي بعد (أيام) — اختياري</label>
      <p-inputNumber [(ngModel)]="pwd.expiresInDays"></p-inputNumber>
    </div>
    <button
      pButton
      icon="pi pi-save"
      label="حفظ"
      (click)="savePolicy()"
    ></button>
  </div>
</div>
